/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-edit-qbpay-details",
  templateUrl: "./edit-qbpay-details.component.html"
})
export class EditQbpayDetailsComponent {
  @Input() parentGroup!: FormGroup;
}
